<template>
  <div>
    <CrudList
      title="Banners"
      storeName="Banners"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/app_ads"
      :breadcrumbs="[
        {
          text: 'Marketing y comunicación',
          disabled: false,
          href: '/admin/banners'
        },
        {
          text: 'Banners',
          disabled: false,
          href: '#'
        }
      ]"
    >

    <template v-slot:banner_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.banner_picture" class="banner">
            <img :src="item.banner_picture" alt=""  />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>

    </CrudList>
  </div>
</template>
<style>
  .banner{
    width: 120px !important;
    height: auto !important;
    border-radius: 0 !important;
  }
</style>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
